export const GRETA_COMPOSER_MIN_ROWS = 2

export const GRETA_COMPOSER_MAX_ROWS = 8

export const GRETA_COMPOSER_MAX_LENGTH = 4000

export const GRETA_COMPOSER_DOUBLE_CLICK_TIMEOUT_MS = 1000

export const QA_NAME_GRETA_AI_CHAT_COMPOSER = 'gretaAIChatComposer'

export const QA_NAME_GRETA_AI_CHAT_COMPOSER_INPUT = 'gretaAIChatComposerInput'

export const QA_NAME_GRETA_AI_CHAT_COMPOSER_SEND = 'gretaAIChatComposerSend'

export const QA_NAME_GRETA_AI_CHAT_COMPOSER_STOP = 'gretaAIChatComposerStop'

export const GRETA_LIMIT_COMPOSER_PLACEHOLDER_KEY =
  'Greta.LimitComposerPlaceholderKey'

export const GRETA_LOCKED_COMPOSER_PLACEHOLDER_KEY =
  'Greta.LockedComposerPlaceholderKey'
